import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const List = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;

  .item {
    cursor: pointer;
    border: 1px solid transparent;

    &.chosen {
      background: ${theme.palette.background.lightGray};
    }

    &:hover {
      border-color: ${theme.palette.grey['500']};
    }
  }
`;

export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
`;
